<template>
  <div>
    <div class="text-subtitle-2 mb-1">{{ numero }}º desconto</div>
    <v-row dense>
      <v-col cols="7">
        <e-label>Valor</e-label>
        <v-currency-field
          :value="valor"
          locale="pt-BR"
          :rules="[campoObrigatorio]"
          prefix="R$"
          required
          dense
          solo
          @input="$emit('update:valor', $event)"
        />
      </v-col>
      <v-col cols="5">
        <e-label>Dia</e-label>
        <v-text-field
          :value="dia"
          type="number"
          :max="31"
          :min="1"
          :rules="[diaObrigatorio]"
          required
          dense
          solo
          @input="$emit('update:dia', $event)"
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { campoEstaPreenchido, diaEstaValido } from "./parcelasDaMatricula";

/** Valor e dia de uma faixa de desconto da mensalidade, juntos. Use com `.sync`. */
export default {
  name: "ECampoDesconto",
  props: {
    numero: { type: Number, required: true },
    valor: { type: [Number, String], default: null },
    dia: { type: [Number, String], default: null },
  },
  methods: {
    campoObrigatorio(valor) {
      return campoEstaPreenchido(valor) || "Campo obrigatório";
    },
    diaObrigatorio(valor) {
      return diaEstaValido(valor) || "Informe um dia entre 1 e 31";
    },
  },
};
</script>
